import "../styles/merchants.css";
import React, { useEffect, useState } from 'react';
//import CardService from '../services/card_services';
import BusinessService from '../services/business_services';

import LOYALBUDS from "../media/images/loyalbuds_dark_pro.png";
import BUD_SET_ONE from "../media/images/bud_set_five.png";
import BUD_SET_TWO from "../media/images/bud_set_two.png";
import BOARD from "../media/images/board.png";
import MAPMARKER from "../media/images/map_marker.png";
import ROCKET from "../media/images/rocket.png";
import NOTIF from "../media/images/notif.png";
import ENGAGE from "../media/images/engage.png";
import MORE from "../media/images/more.png";
import APPLICATION from "../media/images/mckup_05.png";
import APPLICATION2 from "../media/images/application2.png";
//import Tilt from 'react-parallax-tilt';
import { FaAppStore, FaDiscord, FaGooglePlay, FaInstagram, FaTwitter, FaUserAstronaut, FaShoppingBag, FaPaperPlane, FaSignInAlt, FaFacebook } from "react-icons/fa";

//TRANSLATION
import { useTranslation } from 'react-i18next';

function Merchants() {
  const { t, i18n } = useTranslation();
  const [lastBusiness, setLastBusiness] = useState(null);
  /* const [buds, setBuds] = useState([]);
  const [selectedBud, setSelectedBud] = useState();
  const [hideBud, setHidebud] = useState(false);
  const [displayDesc, setDisplayDesc] = useState(false);

  const loadBuds = async () => {
    const buds = await CardService.getBusinessCards()
    setBuds(buds)
  } */

  /* const triggerSelection = (bud_uuid) => {
    setSelectedBud(bud_uuid)
    setHidebud(true)
    setTimeout(() => {
      setDisplayDesc(true)
    }, 500);
  }

  const cancelSelection = () => {
    setSelectedBud(null)
    setHidebud(false)
    setDisplayDesc(false)
  }

  const saveBud = async (bud) => {
    window.localStorage.setItem('choosen_bud', JSON.stringify(bud))
    window.location.href = "/merchants/register"
  } */

  useEffect(() => {
    i18n.changeLanguage('fr');
    const loadLastBusiness = async () => {
      try {
        const data = await BusinessService.lastBusinessRegistered();
        setLastBusiness(data);
      } catch (error) {
        console.error('Error loading last business:', error);
      }
    };
    loadLastBusiness();
  }, []);

  return (
    <div className="m">
      <div className="container">
        <header>
          <a href="/players" className="left_entry"><FaUserAstronaut /> {t('home.player')}</a>
          <a href="/merchants" className="left_entry active"><FaShoppingBag /> {t('home.merchants')}</a>
          <div className="sign_in" onClick={() => window.location.href = "/merchants/signin"}>
            {t('merchants.signin')}
          </div>
          <img src={LOYALBUDS} className="logo" alt="logo LoyalBuds" />
          <a href="https://discord.com/invite/sHbvCwhPGz" target="_blank" rel="noreferrer" className="right_entry social"><FaDiscord /></a>
          <a href="https://twitter.com/LoyalBuds" target="_blank" rel="noreferrer" className="right_entry social"><FaTwitter /></a>
          <a href="https://www.facebook.com/loyalbudsapp" target="_blank" rel="noreferrer" className="right_entry social"><FaFacebook /></a>
          <a href="https://www.instagram.com/loyalbudsgame/" target="_blank" rel="noreferrer" className="right_entry social"><FaInstagram /></a>
          <span className="right_entry search_entry" onClick={() => window.location.href = "/merchants/signin"}><FaSignInAlt /></span>
          <span className="right_entry mobile_entry active" onClick={() => window.location.href = "/merchants"}><FaShoppingBag /></span>
          <span className="right_entry mobile_entry" onClick={() => window.location.href = "/players"}><FaUserAstronaut /></span>
        </header>
        <div className="content pro">
          <div className="hero-col hero-col-img">
            <img src={APPLICATION} className="application" alt="LoyalBuds application" />
          </div>
          <div className="hero-col hero-col-text">
            <span className="notice">Faites entrer votre commerce dans le Game</span>
            <h1 className="title">
              Attirez plus de clients dans votre commerce grâce à la gamification
            </h1>
            <p>
              Créez la Carte de votre commerce dans le jeu pour augmenter la fréquentation et créer du lien durable avec vos clients
            </p>
            <div className="signup_button" style={{ display: "block", marginLeft: "20px" }} onClick={() => window.location.href = "/merchants/register"}>
              Créez votre compte
              GRATUITEMENT
            </div>
          </div>
          {lastBusiness && (
            <div className="immersive last-business-section">
              <h1 className="title section-title">
                Rejoignez les <span className="nb-highlight">{lastBusiness.nb_business} commerces</span>
                <br />
                présents sur LoyalBuds
              </h1>
              <p className="section-subtitle">
                Découvrez {lastBusiness.business_info.business_name}
              </p>

              <div className="cards-container">
                {/* Bud Visual - Most Important */}
                <div className="bud-card-wrapper">
                  <div className="bud-card">
                    <div className="bud-card-inner">
                      {/* Horizontal Layout: Bud + Map */}
                      <div className="bud-layout">
                        {/* Bud Image Section */}
                        <div className="bud-image-section">
                          <img
                            src={lastBusiness.bud_info.img_url}
                            alt={lastBusiness.bud_info.bud_name}
                            className="bud-img"
                          />
                          <div className="bud-name-label">
                            {lastBusiness.bud_info.bud_name}
                          </div>
                          <div className="bud-level">
                            {lastBusiness.bud_info.bud_level}
                          </div>
                        </div>

                        {/* Map Section */}
                        <div className="map-section">
                          <div className="map-label-box">
                            <div className="map-label">
                              Récupère ce Bud ici
                            </div>
                          </div>

                          <div className="map-container">
                            <iframe
                              title="Business Location"
                              className="map-iframe"
                              loading="lazy"
                              allowFullScreen
                              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAb_1hjfCPDk9JKXS4mraMQyVsF3_yX1zg&q=${lastBusiness.business_info.geolocation.lat},${lastBusiness.business_info.geolocation.lng}&zoom=15`}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Business Info & Map */}
                <div className="business-info-wrapper">
                  <div className="business-info">
                    {lastBusiness.business_info.logo_url && (
                      <div className="business-logo-container">
                        <img 
                          src={lastBusiness.business_info.logo_url}
                          alt={`${lastBusiness.business_info.business_name} logo`}
                          className="business-logo"
                        />
                      </div>
                    )}
                    <h2 className="business-name">
                      {lastBusiness.business_info.business_name}
                    </h2>

                    <div className="activity-badge-container">
                      <div className="activity-badge">
                        {lastBusiness.business_info.business_activity.fr}
                      </div>
                    </div>

                    {/* Place Photo */}
                    {lastBusiness.business_info.place_photo && (
                      <div className="place-photo-container">
                        <img
                          src={lastBusiness.business_info.place_photo}
                          alt={lastBusiness.business_info.business_name}
                          onError={(e) => {
                            e.target.parentElement.style.display = 'none';
                          }}
                          className="place-photo"
                        />
                      </div>
                    )}

                    <p className="business-address">
                      📍 {lastBusiness.business_info.address}
                      <br />
                      {lastBusiness.business_info.city}, {lastBusiness.business_info.country}
                    </p>

                    {lastBusiness.business_info.business_phone && (
                      <p className="business-phone">
                        📞 {lastBusiness.business_info.business_phone}
                      </p>
                    )}

                    {lastBusiness.business_info.website && (
                      <p className="business-website">
                        🌐 <a 
                          href={lastBusiness.business_info.website} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="website-link"
                        >
                          {lastBusiness.business_info.website.replace(/^https?:\/\/(www\.)?/, '')}
                        </a>
                      </p>
                    )}

                    <p className="business-description">
                      {lastBusiness.business_info?.description?.fr || lastBusiness.business_info?.description?.en}
                    </p>
                  </div>
                </div>
              </div>
              <div className="signup_button register-button" onClick={() => window.location.href = "/merchants/register"}>
                Enregistrez votre commerce
              </div>
            </div>
          )}
          <div className="immersive" style={{ marginTop: "120px" }}>
            <h1 className="title" style={{ textAlign: "center" }}>
              Dynamisez votre commerce
            </h1>
            <div className="box box_left" style={{ backgroundColor: "#eee" }}>
              <h2 style={{ color: "#000" }}>
                🚀 Attirez une nouvelle clientèle
              </h2>
              <p style={{ color: "#333" }}>
                {t('merchants.new_clients_blurb')}
              </p>
              <h2 style={{ color: "#000" }}>
                ✨ Créez des expériences immersives
              </h2>
              <p style={{ color: "#333" }}>
                {t('merchants.loyal_clients_blurb')}
              </p>
              <p>
                <br />
              </p>
            </div>
            <img src={BUD_SET_ONE} className="bud_set" alt="Set of Buds" />
            <div className="box box_right" style={{ backgroundColor: "#eee" }}>
              <h2 style={{ color: "#000" }}>
                🕹️ Gamifiez la relation client
              </h2>
              <p style={{ color: "#333" }}>
                {t('merchants.connect_blurb')}
              </p>
            </div>
          </div>
        </div>
        <div className="content simple">
          <div className="immersive" style={{ marginTop: "20px", marginBottom: "0" }}>
            <h1 className="title" style={{ textAlign: "center" }}>
              Un outil simple et innovant
            </h1>
            <div className="box" style={{ margin: "10px", backgroundColor: "#eee", minHeight: "400px" }}>
              <img src={MAPMARKER} style={{ height: "180px" }} alt="Map marker" />
              <h2 style={{ color: "#333", marginTop: "0" }}>
                🎯 Se faire connaître
              </h2>
              <p style={{ color: "#555" }}>
                Créez et gérez en temps réel votre fiche commerçant géolocalisée publiée dans l'application.
                <br />
                Grâce à LoyalBuds, de nombreux joueurs peuvent découvrir votre commerce et vos offres.
              </p>
            </div>
            <div className="box" style={{ margin: "10px", backgroundColor: "#eee", minHeight: "400px" }}>
              <img src={NOTIF} style={{ height: "180px" }} alt="rocket" />
              <h2 style={{ color: "#333", marginTop: "0" }}>
                📢 Communiquer
              </h2>
              <p style={{ color: "#555" }}>
                Envoyez des notifications mobiles ou email aux porteurs de votre carte
              </p>
            </div>
            <div className="box" style={{ margin: "10px", backgroundColor: "#eee", minHeight: "400px" }}>
              <img src={BOARD} style={{ height: "180px" }} alt="board" />
              <h2 style={{ color: "#333", marginTop: "0" }}>
                🎭 Mieux connaître vos clients
              </h2>
              <p style={{ color: "#555" }}>
                Accédez à des informations qualifiées sur vos clients et leurs habitudes de consommation
              </p>
            </div>
          </div>
          <div className="immersive" style={{ marginTop: "-80px" }}>
            <div className="box" style={{ margin: "10px", backgroundColor: "#eee", minHeight: "400px" }}>
              <img src={ENGAGE} style={{ height: "180px" }} alt="rocket" />
              <h2 style={{ color: "#333", marginTop: "0" }}>
                📣 Engager vos clients
              </h2>
              <p style={{ color: "#555" }}>
                Incitez vos clients à revenir pour scanner votre QR code, participer à des quêtes et gagner des récompenses
              </p>
            </div>
            <div className="box" style={{ margin: "10px", backgroundColor: "#eee", minHeight: "400px" }}>
              <img src={ROCKET} style={{ height: "180px" }} alt="rocket" />
              <h2 style={{ color: "#333", marginTop: "0" }}>
                🧠 Créer des expériences uniques
              </h2>
              <p style={{ color: "#555" }}>
                Créez des quêtes et des jeux concours et transformez vos clients en une communauté
              </p>
            </div>
            <div className="box" style={{ margin: "10px", backgroundColor: "#eee", minHeight: "400px" }}>
              <img src={MORE} style={{ height: "180px" }} alt="rocket" />
              <h2 style={{ color: "#333", marginTop: "0" }}>
                🎉 Et plus encore !
              </h2>
              <p style={{ color: "#555" }}>
                Sécurisez les données de vos clients
                <br />
                Supprimez la fraude à la carte de fidélité
              </p>
            </div>
          </div>
          <div className="content pro how-it-works">
            <div className="hero-col hero-col-img">
              <img src={APPLICATION2} className="application" alt="LoyalBuds application" />
            </div>
            <div className="hero-col hero-col-text">
              <h1 className="title">Comment ça marche</h1>
              <h2 style={{ marginBottom: "2px", paddingLeft: "20px", color: "#333" }}>
                Créez votre compte Pro
              </h2>
              <p>
                Enregistrez votre commerce, créez et publiez votre fiche commerçant géolocalisée et choisissez votre carte de fidélité
              </p>
              <h2 style={{ marginBottom: "2px", paddingLeft: "20px", color: "#333" }}>
                Faites scanner votre QR code
              </h2>
              <p>
                Affichez votre QR code dans votre établissement et proposez à vos clients de le scanner
              </p>
              <h2 style={{ marginBottom: "2px", paddingLeft: "20px", color: "#333" }}>
                Communiquez avec vos clients
              </h2>
              <p>
                Restez en contact en envoyant des messages et notifications, et créez un lien plus fort grâce au jeu
              </p>
              <h2 style={{ marginBottom: "2px", paddingLeft: "20px", color: "#333" }}>
                Consultez vos données clients
              </h2>
              <p>
                Ayez une connaissance de vos clients et de leurs habitudes comme jamais auparavant et consultez les analytics de fréquentation de votre établissement
              </p>
              <div className="signup_button" style={{ display: "block", marginLeft: "20px" }} onClick={() => window.location.href = "/merchants/register"}>
                Démarrez
                MAINTENANT
              </div>
            </div>

            <div className="immersive" style={{ marginTop: "120px" }}>
              <h1 className="title" style={{ textAlign: "center" }}>
                Pourquoi LoyalBuds ?
              </h1>
              <h2 style={{ marginTop: "2px", paddingLeft: "20px", color: "#333" }}>
                L’idée de LoyalBuds est née d’un constat simple, dans un petit bar de quartier, peu après la crise du Covid.
              </h2>
              <div className="box box_left" style={{ backgroundColor: "#eee" }}>
                <p style={{ color: "#333" }}>
                  Alors que de nombreux commerces de proximité fermaient leurs portes ou luttaient pour survivre, nous repensions à ce moment où des foules entières s’étaient ruées dehors pour chasser des créatures virtuelles sur Pokémon Go — un jeu immersif, accessible uniquement depuis un smartphone.
                </p>
                <p>
                  <br />
                </p>
                <p style={{ color: "#333" }}>
                  Et pourtant… à quelques mètres de là, des boutiques bien réelles, tenues par des commerçants passionnés, restaient vides.
                </p>
                <p>
                  <br />
                </p>
                <p style={{ color: "#333" }}>
                  Nous avons vu dans ce contraste une opportunité évidente : et si la puissance du jeu, de l’interaction communautaire et du digital pouvait servir à redynamiser le commerce local ?
                </p>
              </div>
              <img src={BUD_SET_TWO} className="bud_set_two" alt="Set of Buds" />
              <div className="box box_right" style={{ backgroundColor: "#eee" }}>
                <h2 style={{ color: "#000" }}>
                  🎯 Une solution ludique et innovante
                </h2>
                <p style={{ color: "#333" }}>
                  Pour attirer, engager et fidéliser une nouvelle génération de clients dans les centres-villes.
                </p>
                <h2 style={{ color: "#000" }}>
                  📲 Un pont entre l’univers du gaming et la réalité des commerçants
                </h2>
                <p style={{ color: "#333" }}>
                  Pour créer des expériences immersives qui font revenir les gens en boutique.
                </p>
                <h2 style={{ color: "#000" }}>
                  🤝 Une vision
                </h2>
                <p style={{ color: "#333" }}>
                  Faire du digital un levier concret pour soutenir l’économie <strong>réelle et locale</strong>.
                </p>
              </div>
            </div>
            <h1 className="title" style={{ marginTop: "20px", textAlign: "center" }}>
              Contactez-nous
            </h1>
            <h2 style={{ marginTop: "-2px", paddingLeft: "20px", color: "#333", textAlign: "center" }}>Nous pouvons vous aider à redynamiser votre commerce</h2>
            <p style={{ textAlign: "center" }}>
              Prenez contact avec nous pour en savoir plus, devenir partenaire ou créer une carte à votre image !
            </p>
            <div className="button d-block" onClick={() => window.open("mailTo:contact@loyalbuds.io")}>
              <FaPaperPlane /> Nous contacter
            </div>
          </div>
        </div>
        <footer>
          <img src={LOYALBUDS} className="logo" alt="logo LoyalBuds" />
          <p className="privacy">
            <a href="/privacy">{t('privacy.policy')}</a> | <a href="/cgu">{t('cgu.general_terms')}</a>
          </p>
          <p className="copyright">
            {t('home.website')}
            <br />
            <strong>Copyright @Codinsight. 2025</strong>
          </p>
          <div className="entry">
            <p>
              <strong>{t('home.editor_title')}</strong>
            </p>
            <p>
              {t('home.editor_blurb')}
            </p>
            <p>
              N° TVA : FR18907943088
              <br />
              Email : contact@codinsight.com
              <br />
              {t('home.director_publishing')}
            </p>
          </div>
          <div className="entry">
            <p>
              <strong>{t('home.hosting')}</strong>
            </p>
            <p>
              {t('home.hosting_details')}
            </p>
            <p>
              Amazon Web Services Inc.
              <br />
              410 Terry Avenue North,
              <br />
              Seattle, WA 98109-5210, USA
            </p>
          </div>
          <div className="entry">
            <div className="link" onClick={() => window.open("https://apps.apple.com/us/app/loyalbuds/id6476626608?platform=iphone")}>
              <FaAppStore />
            </div>
            <div className="link" onClick={() => window.open("https://play.loyalbuds.app")}>
              <FaGooglePlay />
            </div>
            <div className="link" onClick={() => window.open("https://discord.com/invite/sHbvCwhPGz")}>
              <FaDiscord />
            </div>
            <div className="link" onClick={() => window.open("https://twitter.com/LoyalBuds")}>
              <FaTwitter />
            </div>
            <div className="link" onClick={() => window.open("https://www.instagram.com/loyalbudsgame/")}>
              <FaInstagram />
            </div>
            <div className="link" onClick={() => window.open("https://www.facebook.com/loyalbudsapp")}>
              <FaFacebook />
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default Merchants;
